/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ListVisibility {
    FORM_SPECIFIC = 'FormSpecific',
    WORKFLOW_SPECIFIC = 'WorkflowSpecific',
    ORG_WIDE = 'OrgWide',
    PUBLIC = 'Public',
}
